
import React from "react";

const AboutIntro = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="w-20 h-1 bg-kaija-slate rounded-full mx-auto mb-10"></div>
      <p className="text-xl text-gray-700 mb-10 leading-relaxed text-center">
        Olen Kaija Alliksaar — tiimijuht, somaatiline traumateadlik coach, hüpnoterapeut ja sertifitseeritud High Performance Team Coach. Olen ema ja ennekõike naine. Minu missioon on toetada sind sinu teekonnal, aidates ületada takistusi ja luua soovitud tulevikku. Toetan sind turvalises ja mõistvas keskkonnas, arvestades ka varasema trauma mõju sinu elule.
      </p>
    </div>
  );
};

export default AboutIntro;
